<template>
    <div id="app">
        <div id="header" class="fixed-header">
            <Header/>
            <MenuDesktop
                    v-on:menu-selection="menuSelection($event)"
                    v-on:entry-selection="entrySelection($event)"
                    v-on:list-selection="listSelection($event)"/>
        </div>
        <div id="mobile-header" class="fixed-header">
            <MobileHeader
                :open="menuIsOpen"
                v-on:toggle-menu="toggleMenu($event)"/>
            <MenuMobile
                :open="menuIsOpen"
                v-on:menu-selection="mobileMenuSelection($event)"/>
        </div>
        <router-view></router-view>
        <Footer/>
        <Cookies></Cookies>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import MenuDesktop from "./components/MenuDesktop";
    import Footer from "./components/Footer";

    import anime from 'animejs/lib/anime.es.js';
    import contentHelper from "./helpers/content.helper";
    import {setArticles, setGuidedTours, setServices} from "./services/data.service";
    import MobileHeader from "./components/mobile/MobileHeader";
    import MenuMobile from "./components/mobile/MenuMobile";
    import Cookies from "./components/burocracy/Cookies";

    export default {
        name: 'App',
        components: {
            Cookies,
            MenuMobile,
            MobileHeader,
            Footer,
            Header,
            MenuDesktop
        },
        data() {
            return {
                element: null,
                appElement: null,
                headerElement: null,
                services: null,
                menuIsOpen: false
            }
        },
        watch: {
            '$route.query.section': function () {
                if (this.$route.query.section) {
                    setTimeout(() => this.menuSelection(this.$route.query.section), 500);

                }
            }
        },
        created() {
            this.loadServices();
            this.loadGuidedTours();
            this.loadArticles();
        },
        methods: {
            menuSelection(event) {
                if (event === 'portfolio') {
                    this.$router.push({ path: `/portfolio/7wKFQRhKmsq4qxuoqVENx8`});
                } else {
                    const element = document.querySelector("#".concat(event));
                    if (element) {
                        this.scrollToElement(element);
                    } else {
                        this.$router.push({ path: '/', query: { section: event } });
                    }
                }
            },
            mobileMenuSelection (event) {
                this.menuIsOpen = false;
                if (event === 'guided-tours' || event === 'publications') {
                    this.$router.push(`/${event}`).catch(() => {});
                } else {
                    this.menuSelection(event);
                }
            },
            scrollToElement(element) {

                const elementPosition = element.getBoundingClientRect().top;
                const appElementPosition = document.querySelector("#app").getBoundingClientRect().top;
                const headerSize = document.body.offsetWidth > 767 ?
                    document.querySelector("#header").offsetHeight :
                    document.querySelector("#mobile-header").offsetHeight;
                const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

                anime({
                    targets: scrollElement,
                    scrollTop: elementPosition - appElementPosition - headerSize,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            },
            entrySelection(selection) {
                this.$router.push(`/${selection.type}/${selection.id}`).catch(() => {});
            },
            loadServices() {
                contentHelper.client
                    .getEntries({
                        content_type: 'service',
                        'fields.featured': 'true',
                        limit: 6,
                        order: 'fields.order'
                    })
                    .then(response => {
                        setServices(response);
                        this.services = response.toPlainObject();
                    })
                    //TODO - send to log platform
                    .catch(err => console.log(err));
            },
            loadGuidedTours() {
                contentHelper.client
                    .getEntries({
                        content_type: 'guidedTourEntry',
                        'fields.featured': 'true',
                        limit: 10,
                        order: 'fields.order'
                    })
                    .then(response => {
                        setGuidedTours(response);
                    })
                    //TODO - send to log platform
                    .catch(err => console.log(err));
            },
            loadArticles() {
                contentHelper.client
                    .getEntries({
                        content_type: 'article',
                        'fields.featured': 'true',
                        limit: 2,
                        order: '-fields.order'
                    })
                    .then(articles => {
                        setArticles(articles);
                    })
                    //TODO - send to log platform
                    .catch(err => console.log(err));
            },
            listSelection(selection) {
                this.$router.push(`/${selection}`).catch(() => {});
            },
            toggleMenu(isOpen) {
                this.menuIsOpen = isOpen;
            }
        }
    }

</script>

<style lang="scss">
    @import 'assets/styles/global';

    body {
        margin: 0;
        background-color: $bgcolor;
    }

    #app {
        font-family: 'Work Sans', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        overflow-x: hidden;
    }

    #header {
        z-index: 999;
        visibility: visible;
        height: 10em;
    }

    #mobile-header {
        z-index: 999;
        background-color: $primary;
        visibility: hidden;
        height: $mobile-bar-height;
    }

    @media only screen and (max-width: 767px) {
        #header {
            visibility: hidden;
        }

        #mobile-header {
            visibility: visible;
        }
    }

    .fixed-header {
        position: fixed;
        width: 100%;
        background-color: $bgcolor;
    }
</style>
